import React from 'react';
import styled from 'styled-components';
import ImpContainer from '../../Atoms/ImpContainer/ImpContainer';
import ImpFlex from '../../Atoms/ImpFlex/ImpFlex';
import ImpFlexItem from '../../Atoms/ImpFlexItem/ImpFlexItem';
import ImpPad from '../../Atoms/ImpPad/ImpPad';
import { colors } from '../../DesignSystem/colors';
import ImpDivider from '../ImpDivider/ImpDivider';
import ImpText from '../ImpText/ImpText';
export const LIST_ITEM_SIDE_MARGIN = '16px';
export const getListItemPadding = (large) => {
    return large ? 'xl' : 'l';
};
export const LoadingIndicator = ({ dividerBottom, hideSquareLoader, }) => (React.createElement(ImpPad, { padding: `0px ${LIST_ITEM_SIDE_MARGIN}` },
    React.createElement(ImpFlex, { direction: "row", align: "center", gap: "l", fluid: true, dataTestId: "list-content-container" },
        !hideSquareLoader && (React.createElement(ImpContainer, { isLoading: true, height: "40px", width: "40px" })),
        React.createElement(ImpFlexItem, { flexGrow: 1 },
            React.createElement(ImpContainer, { dataTestId: "list-text-container" },
                React.createElement(ImpFlex, { direction: "column", fluid: true },
                    React.createElement(ImpPad, { paddingTop: "l", paddingBottom: "l" },
                        React.createElement(ImpContainer, { textAlign: "left" },
                            React.createElement(ImpFlex, { direction: "column", gap: "xs" },
                                React.createElement(ImpContainer, { isLoading: true, height: "24px", width: "100px" }),
                                React.createElement(ImpContainer, { isLoading: true, height: "24px", width: "168px" })))),
                    dividerBottom && React.createElement(ImpDivider, { isLoading: true })))))));
const LeadingTextContainer = styled(ImpContainer) `
  text-align: left;
  // flex: 0 0 auto;
  ${(props) => (props.nowrap ? 'min-width: 0;' : '')}
  padding-right: 8px;
  width: fit-content;
`;
const DynamicText = styled(ImpText) `
  white-space: ${(props) => (props.nowrap ? 'nowrap' : 'normal')};
  overflow: ${(props) => (props.nowrap ? 'hidden' : 'visible')};
  text-overflow: ${(props) => (props.nowrap ? 'ellipsis' : 'clip')};
`;
export function LeadingText({ nowrap = false, title, subtitle, destructive, }) {
    return (React.createElement(LeadingTextContainer, { nowrap: nowrap },
        React.createElement(ImpFlex, { direction: "column", align: "left" },
            title && (React.createElement(DynamicText, { typography: "body1", dataTestId: "list-title", color: destructive
                    ? colors.content.onSurfaceError
                    : colors.content.onBackground, nowrap: nowrap }, title)),
            subtitle && (React.createElement(DynamicText, { typography: "body2", color: colors.content.onBackgroundVariant, dataTestId: "list-subtitle", nowrap: nowrap }, subtitle)))));
}
export function TrailingText({ title, subtitle }) {
    return (React.createElement(ImpContainer, { textAlign: "right" },
        React.createElement(ImpFlex, { direction: "column", align: "flex-end", justify: "center" },
            title && (React.createElement(ImpText, { typography: "body1", dataTestId: "list-trailing-title" }, title)),
            subtitle &&
                (typeof subtitle === 'string' ? (React.createElement(ImpText, { color: colors.content.onBackgroundVariant, typography: "body2", dataTestId: "list-trailing-subtitle" }, subtitle)) : (React.createElement(React.Fragment, null, subtitle))))));
}
//# sourceMappingURL=ImpListItemComponents.js.map